import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.diagnosis');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-diagnosis',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.diagnosis/view.scss */
/* src/app/page.admin.diagnosis/view.scss: no such file or directory */`],
})
export class PageAdminDiagnosisComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public categories: string[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public searchText: string = '';
    public categoryFilter: string = '';
    public pages: number[] = [];
    public totalPages: number = 0;

    public showEditor: boolean = false;
    public editItem: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.loadCategories();
        await this.load();
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories");
        if (code === 200) this.categories = data;
    }

    public async load(page: number = 1) {
        this.page = page;
        const { code, data } = await wiz.call("search", {
            page: this.page, dump: this.dump,
            text: this.searchText, category: this.categoryFilter
        });
        if (code === 200) {
            this.items = data.rows;
            this.total = data.total;
            this.totalPages = Math.ceil(this.total / this.dump);
            this.pages = [];
            let start = Math.max(1, this.page - 2);
            let end = Math.min(this.totalPages, start + 4);
            start = Math.max(1, end - 4);
            for (let i = start; i <= end; i++) this.pages.push(i);
        }
        await this.service.render();
    }

    public openNew() {
        this.editItem = { code: '', name: '', category: '', description: '', is_ktm: true };
        this.showEditor = true;
    }

    public openEdit(item: any) {
        this.editItem = { ...item };
        this.showEditor = true;
    }

    public closeEditor() {
        this.showEditor = false;
        this.editItem = {};
    }

    public async saveItem() {
        if (!this.editItem.code || !this.editItem.name) {
            await this.service.modal.show({ title: '알림', message: '코드와 진단명은 필수입니다.', action: '확인' });
            return;
        }
        const { code } = await wiz.call("save", { data: JSON.stringify(this.editItem) });
        if (code === 200) {
            this.closeEditor();
            await this.load(this.page);
        }
    }

    public async deleteItem(item: any) {
        const res = await this.service.modal.show({
            title: '삭제 확인', message: `'${item.name}' 진단코드를 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'btn-red'
        });
        if (res) {
            const { code } = await wiz.call("delete", { id: item.id });
            if (code === 200) await this.load(this.page);
        }
    }
}

export default PageAdminDiagnosisComponent;